{
  "name": "ok-app-support-portal",
  "version": "2026.10.26-build.2",
  "packageManager": "pnpm@12.6.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --o",
    "start:test": "node scripts/stage-appsettings.js && ng serve --o --configuration=test",
    "build": "ng build",
    "build:test": "ng build --configuration test",
    "build:prodtest": "ng build --configuration prodtest",
    "build:prod": "ng build --configuration production",
    "test": "ng test",
    "test:ci": "npx vitest run --coverage",
    "code-coverage": "npx vitest run --coverage",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "e2e": "npx playwright test --project=smoke",
    "e2e:headed": "npx playwright test --project=smoke --headed",
    "e2e:ui": "npx playwright test --project=smoke --ui",
    "e2e:setup": "npx ok-e2e-init"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.0.6",
    "@angular/cdk": "^22.0.4",
    "@angular/common": "^22.0.6",
    "@angular/compiler": "^22.0.6",
    "@angular/core": "^22.0.6",
    "@angular/forms": "^22.0.6",
    "@angular/material": "^22.0.4",
    "@angular/material-luxon-adapter": "^22.0.4",
    "@angular/platform-browser": "^22.0.6",
    "@angular/platform-browser-dynamic": "^22.0.6",
    "@angular/router": "^22.0.6",
    "angular-oauth2-oidc": "^22.0.0",
    "jwt-decode": "^4.0.0",
    "luxon": "^3.7.2",
    "ok-angular-shared": "^22.0.10",
    "rxjs": "~7.8.1",
    "tslib": "^2.6.3",
    "zone.js": "^0.16.1"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.6.0",
    "@analogjs/vitest-angular": "^2.6.0",
    "@angular/build": "^22.0.6",
    "@angular/cli": "^22.0.6",
    "@angular/compiler-cli": "^22.0.6",
    "@angular/language-service": "^22.0.6",
    "@dotenvx/dotenvx": "^1.33.0",
    "@eslint/js": "^10.0.1",
    "@ngneat/spectator": "^22.1.0",
    "@oxc-project/runtime": "^0.122.0",
    "@playwright/test": "^1.49.1",
    "@types/google.maps": "^3.65.4",
    "@types/luxon": "^3.7.1",
    "@types/node": "^25.9.1",
    "@vitest/browser-playwright": "^4.1.6",
    "@vitest/coverage-v8": "^4.1.6",
    "angular-eslint": "^22.0.0",
    "baseline-browser-mapping": "^2.8.31",
    "cross-conf-env": "^1.3.0",
    "cross-env": "^10.0.0",
    "eslint": "^10.4.0",
    "eslint-config-prettier": "^10.0.1",
    "eslint-plugin-prettier": "^5.2.1",
    "npm-run-all": "^4.1.5",
    "ok-e2e-auth": "^1.1.5",
    "prettier": "^3.3.3",
    "tsx": "^4.19.4",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.44.0",
    "vite": "^8.0.2",
    "vitest": "^4.1.0"
  }
}
